module.exports = __webpack_public_path__ + "static/img/sugarSync.7b9166b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/sugarSync.svg
// module id = pK+t
// module chunks = 2